import React, { useState, useEffect, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate, useParams } from "react-router";
import { LanguageContext } from "../../App";
import Modal from "../Modal/Modal";
import Button from "../Button/Button";
import "../../icons";

const languages = [
    { code: "en", label: "English" },
    { code: "fr", label: "Français" },
    { code: "de", label: "Deutsch" },
    { code: "es", label: "Español" },
    { code: "zh", label: "中文(简体)" },
    { code: "ru", label: "Русский" },
    { code: "jp", label: "日本語" },
    { code: "kr", label: "한국어" },
    { code: "it", label: "Italiano" },
    { code: "pl", label: "Polski" },
    { code: "pt", label: "Português" },
    { code: "tr", label: "Türkçe" }
];

function LanguageSelector() {
    const { lang } = useParams();
    const navigate = useNavigate();
    const { setLanguage } = useContext(LanguageContext); 
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (!languages.some(l => l.code === lang)) {
            navigate("/en", { replace: true });
        }
        localStorage.setItem("selectedLanguage", lang);
    }, [lang, navigate]);

    const handleLanguageChange = (newLang) => {
        if (lang === newLang) return;
        setLanguage(newLang);
        localStorage.setItem("selectedLanguage", newLang);

        const currentPath = window.location.pathname.split("/").slice(2).join("/");
        navigate(`/${newLang}/${currentPath}`, { replace: true });

        setIsOpen(false);
    };

    return (
        <div className="language-selector">
            <Button
                label={
                    <>
                        <FontAwesomeIcon icon="globe" className="icon-spacing" />
                        {languages.find(langItem => langItem.code === lang)?.label || "English"}
                    </>
                }
                onClick={() => setIsOpen(true)}
                type="primary"
            />

            <Modal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                title="Sélectionner une langue"
            >
                <div className="modal-content modal-two-columns modal-full-width">
                    {languages.map((langItem) => (
                        <Button
                            key={langItem.code}
                            label={langItem.label}
                            onClick={() => handleLanguageChange(langItem.code)}
                            type="primary"
                        />
                    ))}
                </div>
            </Modal>
        </div>
    );
}

export default LanguageSelector;
